export default __webpack_public_path__ + "alberta-activities.fae9ba6257b84fa14a21.svg";